var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"primary","size":_vm.size,"disabled":_vm.ids.length < 1},on:{"click":_vm.open}},[_c('i',{staticClass:"fa fa-eyedropper"}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }